import React, { Component } from 'react';

import AutoDetectionsModel from './AutoDetectionsModel';

import { Row, Col, Card, Spin, message } from 'antd';

class AutoDetectionsTableExpander extends Component {

    state = {
        data: null
    }

    async componentWillMount() {
        try {
            let data = await Promise.all([
                AutoDetectionsModel.getAttachment(this.props.images.Context),
                AutoDetectionsModel.getAttachment(this.props.images.LPR)
            ]);            
            this.setState({
                data: data
            });
        } catch (err) {
            message.error('Detail přestupku se nepodařilo načíst');
        }
    }

    onClickImg(base64Img) {
        let image = new Image();
        image.src = base64Img;

        let imgWidth = image.width;
        let imgHeight = image.height;

        let screenWidth = window.screen.availWidth;
        let screenHeight = window.screen.availHeight;

        let newWindowWidth = (imgWidth > (screenWidth - (screenWidth * 0.1)))
            ? screenWidth - (screenWidth * 0.10)
            : imgWidth + (imgWidth * 0.1);

        let newWindowHeight = (imgHeight > (screenHeight - (screenHeight * 0.1)))
            ? screenHeight - (screenHeight * 0.10)
            : imgHeight + (imgHeight * 0.1);

        let w = window.open(null, '_blank', 'width=' + newWindowWidth + ',height=' + newWindowHeight + ',resizable=1');
        w.document.write(image.outerHTML)
    }

    render() {
        if (this.state.data !== null) {
            return (
                <Row gutter={16}>
                    {this.state.data.map((child, idx) => {
                        let dataImg = "data:image/jpeg;base64," + child;
                        return (
                            <Col span={4} key={idx}>
                                <Card
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        this.onClickImg(dataImg)
                                    }}
                                    cover={
                                        <img src={dataImg} />
                                    }>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            );
        } else {
            return (
                <div style={{
                    textAlign: 'center',
                    borderRadius: '4px',
                    marginBottom: 20,
                    padding: '30 50',
                    margin: '20px 0'
                }} >
                    <Spin />
                </div >
            )
        }

    }
}

export default AutoDetectionsTableExpander;


// WEBPACK FOOTER //
// ./src/components/AutoDetectionsTableExpander.js